
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class CaptchaService {
  private isVerified = new BehaviorSubject<boolean>(false);
  isVerified$ = this.isVerified.asObservable();
  constructor() { }
  setVerified(verified: boolean) {
    this.isVerified.next(verified);
  }
  
}
